// extracted by mini-css-extract-plugin
module.exports = {"cta":"Submit-module__cta___kjj9T","font":"Submit-module__font___3BafT"};